<!-- ---Table list- -->

<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
            <div class="relative">
                <input type="text" [(ngModel)]="search" (input)="onSearchInput()" placeholder="Search.."
                    class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <div>
                <select (change)="onSelectStatus()" [(ngModel)]="status" id="inputStatus" class="min-w-40">
                    <!-- <option value="">Select Status</option> -->
                    <option [ngValue]="true">Active</option>
                    <option [ngValue]="false">Inactive</option>
                </select>
            </div>
        </div>
        <div *ngIf="filteredDrivers && filteredDrivers.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (filteredDrivers.length != numberOfRecords? (numberOfRecords
                -filteredDrivers.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div>
            <button [routerLink]="'/drivers/add'" class="btn btn-secondary">
                Add
            </button>
        </div>
    </div>
<div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
        <div class="flow-root h-full overflow-y-auto">
            <div class="-my-2">
                <div class="inline-block min-w-full py-2 align-middle">
                    <table class="min-w-full border-separate border-spacing-0">
                        <thead>
                            <tr>
                                <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                #</th>
                                <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                Action</th>
                                <th
                                    class="abc sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Name</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Contact No.</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    DOB</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    License Number</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Email</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Languages</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    City</th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        State
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Created At
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Updated At
                                    </th>
                                <!-- <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Filling Status</th> -->
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Approve Status</th>
                                <th
                                    class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    Status</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let driver of filteredDrivers | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index">
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                {{i+1}}
                                </td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <div class="flex justify-start">
                                        <button [appToolTip]="'Edit'"
                                         class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400"
                                            (click)="openDriverModal(driver)">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                            stroke="currentColor" class="size-5 ">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                            </svg>
                                        </button>
                                        <ng-container *ngIf="driver.isActive" >
                                            <div class="mx-2 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <button [appToolTip]="'Sync'" [disabled]="loading === driver.id" (click)="onSyncDriver(driver.id)" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="h-5" [class.animate-spin]="loading === driver.id">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                </svg>
                                            </button>
                                        </ng-container>
                                    </div>
                                </td>
                                <!-- Name -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{(driver.displayName | titlecase) || 'N/A'}}
                                </td>
                                <!-- Contact No. -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="driver?.phoneNumber">
                                    {{driver?.phoneNumber || 'N/A'}}</td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{driver.dob | date:'MM/DD/YYYY'}}</td>
                                <!-- License Number -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{((driver?.driverLicense?.number) | titlecase) || 'N/A'}}</td>
                                <!-- Employment Type -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{driver.email || 'N/A'}}</td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{(driver.languageSpoken | titlecase) || 'N/A'}}</td> <!-- Joining Date -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    {{(driver.address?.city | titlecase) || 'N/A'}}</td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(driver.address?.state  | titlecase) || 'N/A'}}</td>
                                        <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{(driver.createdAt | date: 'MM/DD/YYYY') || 'N/A'}}</td>
                                            <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                                {{(driver.updatedAt | date: 'MM/DD/YYYY') || 'N/A'}}</td>
                                <!-- <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <span [ngClass]="driver.fillingStatus ? 'badge-success':'badge-danger'">{{driver.fillingStatus ?
                                        'Complete'
                                        :
                                        'Incomplete'}}</span>
                                </td> -->
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <span [ngClass]="driver.isApproved ? 'badge-success':'badge-danger'">{{driver.isApproved ?
                                        'Approved'
                                        :
                                        'Unapproved'}}</span>
                                </td>
                                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                    <span [ngClass]="driver.isActive ? 'badge-success':'badge-danger'">{{driver.isActive ? 'Active' :
                                        'Inactive'}}</span>
                                </td> <!-- Status -->
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-2 flex justify-end">
        <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div>
</div>
</section>


<app-driver-edit-modal
  *ngIf="driverModalObj"
  [driver]="driverModalObj"
  (onSave)="onSaveDriver($event)"
  (onCloseModal)="onCloseDriverEditModal()"
></app-driver-edit-modal>
